import { render, staticRenderFns } from "./workflowItem.vue?vue&type=template&id=36aaca29&scoped=true&"
import script from "./workflowItem.vue?vue&type=script&lang=js&"
export * from "./workflowItem.vue?vue&type=script&lang=js&"
import style0 from "./workflowItem.vue?vue&type=style&index=0&id=36aaca29&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36aaca29",
  null
  
)

export default component.exports